module.exports = __webpack_public_path__ + "img/live_yeebet.db148f09.png";